// eslint-disable-next-line @typescript-eslint/no-unused-vars
__webpack_public_path__ =
  window.inletsConfig.publicPathPrefix === '/'
    ? window.inletsConfig.publicPathPrefix
    : `${window.inletsConfig.publicPathPrefix}/${WEBPACK_INLET_PORTAL}/${WEBPACK_INLET_NAME}/`
